<!-- <nz-spin [nzSpinning]="isSpinning"> -->
<div class="max-w-[70.75rem] mx-auto py-2 mx:py-4">
  <div class="mx:mb-[36px] sm:mb-4">
    <h1 class="text-2xl mx:text-[28px] sm:text-[16px] leading-[35px] font-bold text-blue500 mx:mb-[30px] sm:mb-2">
      {{'DOWNLOAD_CENTER_TITLE' |
      translate}}</h1>
    <p class="text-black text-[20px] sm:text-[14px] leading-[25px]">{{'DOWNLOAD_CENTER_DESCRIPTION' | translate}}</p>
  </div>

  <div class="w-full h-[1px] bg-[#D9D9D9] mx:mb-[36px] sm:mb-4"></div>


  <!-- Top Level Tabs -->
  <div class="mb-[34px] w-full" *ngIf="!isMobile">
    <div class="flex items-center rounded-lg w-full">
      <div class="flex space-x-1 text-black scrollbar-hide min-w-0 flex-1 overflow-x-auto" #tabList
        (scroll)="checkScrollState()">
        <button *ngFor="let tab of nodes;let i = index" (click)="handleTopTabClick(tab.id, tab.name)"
          (mouseenter)="onMouseEnterTab(tab.id,i)" (mouseleave)="onMouseLeaveTab()" [ngClass]="[
          'whitespace-nowrap pr-10 text-[18px] transition-colors flex items-center relative',
          tab.id === activeTopTab ? 'text-[#007BC0] hover:text-[#007BC0]' : 'text-black'
        ]">
          <svg-icon [isUrl]="false" [iconName]="'change/folder.svg'" [size]="26"
            [ngClass]="tab.id === activeTopTab ? 'text-[#007BC0] mr-1' : 'text-black mr-1'"></svg-icon>
          <span>{{ tab.name }}</span>
        </button>

      </div>
      <button [disabled]="!canScrollLeft" (click)="scrollLeft()"
        class="p-1 hover:bg-gray-200 rounded ml-2 disabled:opacity-50 disabled:cursor-not-allowed">
        <i nz-icon nzType="left" nzTheme="outline" class="text-sm"></i>
      </button>

      <button [disabled]="!canScrollRight" (click)="scrollRight()"
        class="p-1 hover:bg-gray-200 rounded ml-2 disabled:opacity-50 disabled:cursor-not-allowed">
        <i nz-icon nzType="right" nzTheme="outline" class="text-sm"></i>
      </button>
    </div>
  </div>

  <div *ngIf="hoveredTab !== null && dropdownPosition !== null && getHoveredTabChildren().length > 0 && !isMobile"
    #dropdownRef (mouseenter)="onMouseEnterDropdown(hoveredTab)" (mouseleave)="onMouseLeaveDropdown()"
    class="fixed w-[260px] bg-white border border-gray-200 shadow-lg z-[99999] text-[18px] text-[#343536]"
    [style.left.px]="dropdownPosition.x" [style.top.px]="dropdownPosition.y">
    <div class="p-3">
      <div class="max-h-80 overflow-y-auto">
        <ng-container *ngFor="let folder of getHoveredTabChildren()">
          <div class="relative group">
            <div (click)="handleFolderClick(folder.id, folder.name, $event)" [ngClass]="[
              'flex items-center space-x-2 py-2 px-3 hover:bg-gray-100 rounded cursor-pointer',
              folder.id === activeTopTab ? 'text-[#007BC0]' : 'text-black'
            ]">

              <svg-icon [isUrl]="false" [iconName]="'change/folder.svg'" [size]="26"
                [ngClass]="folder.id === activeTopTab ? 'text-[#007BC0] mr-1' : 'mr-1'"></svg-icon>
              <span class="truncate  inline-block max-w-full" [title]="folder.name">{{ folder.name }}</span>
            </div>
            <div *ngIf="folder.children.length>0" class="ml-3">
              <div class="py-2 pl-8">
                <ng-container *ngFor="let child of folder?.children">
                  <div (click)="handleFolderClick(child.id, child.name, $event)" [ngClass]="[
                  'flex items-center space-x-2 py-2 px-3 hover:bg-gray-100 rounded cursor-pointer rounded truncate',
                  child.id === activeTopTab ? 'text-[#007BC0]' : 'text-black'
                ]">
                    <span class="truncate  inline-block max-w-full" [title]="child.name">{{ child.name }}</span>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>


  </div>

  <!-- Breadcrumb Navigation -->
  <div
    class="mx:flex sm:block items-center justify-between mx:space-x-2 mb-4 mx:mb-8 text-[16px] overflow-x-auto">
    <div class="flex items-center space-x-2 sm:mb-4">
      <span class="whitespace-nowrap text-[#979797]">{{'CURRENT_POSITION' | translate}}:</span>
      <div class="flex flex-wrap overflow-hidden">
        <ng-container *ngFor="let item of currentPath.slice(-3); let i = index">
          <div class="flex items-center min-w-0">
            <i nz-icon nzType="right" nzTheme="outline" *ngIf="i !== 0" class="mx-2 text-xs shrink-0"></i>
            <button (click)="handleBreadcrumbClick(i)"
              class="transition-colors text-[#343536] truncate inline-block sm:max-w-[100px] mx:max-w-[200px] text-sm"
              [ngClass]="{ 'font-medium': i === currentPath.slice(-3).length - 1 }" [title]="item.name">
              {{ item.name }}
            </button>
          </div>
        </ng-container>
      </div>

      <!-- <ng-container *ngFor="let item of currentPath; let i = index">
        <div class="flex items-center whitespace-nowrap ">
          <i nz-icon nzType="right" nzTheme="outline" *ngIf="i!==0" class="mx-2 text-xs"></i>
          <button (click)="handleBreadcrumbClick(i)" [class]="'transition-colors text-[#343536] truncate  inline-block max-w-[260px]' + 
                       (i === currentPath.length - 1 ? 'font-medium' : '')">
            {{ item.name }}
          </button>
        </div>
      </ng-container> -->
    </div>
    <!-- Search Bar -->

    <div class="w-100 sm:w-full">
      <nz-input-group [nzSuffix]="suffixTemplateInfo" class="bosch_input">
        <input type="text" nz-input [placeholder]="'SEARCH_PLACEHOLDER' | translate" (keyup.enter)="onSearch()"
          [(ngModel)]="params.title" class="pr-10" />
        <ng-template #suffixTemplateInfo>
          <i class="search" (click)="onSearch()"></i>
        </ng-template>
      </nz-input-group>
    </div>
  </div>

  <!-- mobile的展开方式-->
  <div *ngIf="isMobile" class="relative sm:mb-4">
    <div class="flex justify-between items-center mb-4 sm:px-4 " *ngIf="currentPath.length>0" (click)="handleLeafClick()">
      <div class="flex items-center" >
        <svg-icon [isUrl]="false" [iconName]="'change/folder-black.svg'" [size]="26" class="text-black mr-1"></svg-icon>
        <span class="text-black">{{ currentPath[0].name }}</span>
      </div>
      <svg-icon [isUrl]="false" [iconName]="'order-select-arrow.svg'" [size]="16" class="mr-1 text-black"></svg-icon>
    </div>
    <div
      class="absolute z-[10000] left-[0px] top-[0px] right-[0px] min-h-[50px] transition-opacity duration-300 ease-in-out w-full sm:px-4 bg-[#fff]"
      *ngIf="nodes.length" [class.opacity-100]="menuVisible" [class.opacity-0]="!menuVisible"
      [class.pointer-events-none]="!menuVisible">
      <svg-icon [isUrl]="false" [iconName]="'change/close.svg'" [size]="24"
        class="absolute right-[16px] top-[8px] z-[12000] cursor-pointer" (click)="handleLeafClick()"></svg-icon>

        <ul nz-menu class="menu" nzMode="inline" [nzSelectedKeys]="[activeTopTabMobile]"
        [nzOpenKeys]="[activeTopTabMobile]" (nzOpenChange)="onOpenChange($event)">
        <div *ngFor="let node of nodes">
          <!-- 1. 叶子节点 -->
          <li nz-menu-item *ngIf="!node.children || node.children.length === 0" [nzKey]="node.id" (click)="onSelect($event,node.id)">
            <svg-icon *ngIf="activeTopTabMobile === node.id" [isUrl]="false" [iconName]="'change/folder-active.svg'" [size]="26" class="mr-1"></svg-icon>
            <svg-icon *ngIf="activeTopTabMobile !== node.id" [isUrl]="false" [iconName]="'change/folder-black.svg'" [size]="26" class="mr-1"></svg-icon>
            <span [ngClass]="{
              'text-[#007BC0]': activeTopTabMobile === node.id,
              'text-black': activeTopTabMobile !== node.id
            }" >{{ node.name }}</span>
          </li>
      
          <!-- 2. 有子级的一级 -->
          <li nz-submenu *ngIf="node.children?.length > 0" [nzKey]="node.id" [nzPaddingLeft]="24" [nzTitle]="title"
            (click)="onSelect($event,node.id)">
            <ng-template #title>
              <svg-icon *ngIf="activeTopTabMobile === node.id" [isUrl]="false" [iconName]="'change/folder-active.svg'" [size]="26" class="mr-1"></svg-icon>
              <svg-icon *ngIf="activeTopTabMobile !== node.id" [isUrl]="false" [iconName]="'change/folder-black.svg'" [size]="26" class="mr-1"></svg-icon>
              <span [ngClass]="{
                'text-[#007BC0]': activeTopTabMobile === node.id,
                'text-black': activeTopTabMobile !== node.id
              }">{{ node.name }}</span>
            </ng-template>
            <ul>
              <ng-container *ngFor="let child of node.children">
                <!-- 3. 二级叶子 -->
                <li nz-menu-item *ngIf="!child.children || child.children.length === 0" [nzKey]="child.id"
                  (click)="onSelect($event,child.id)" [nzPaddingLeft]="48">
                  <svg-icon *ngIf="activeTopTabMobile === child.id" [isUrl]="false" [iconName]="'change/folder-active.svg'" [size]="26" class="mr-1"></svg-icon>
                  <svg-icon *ngIf="activeTopTabMobile !== child.id" [isUrl]="false" [iconName]="'change/folder-black.svg'" [size]="26" class="mr-1"></svg-icon>
                  <span  [ngClass]="{
                    'text-[#007BC0]': activeTopTabMobile === child.id,
                    'text-black': activeTopTabMobile !== child.id
                  }">{{ child.name }}</span>
                </li>
      
                <!-- 4. 有三级的二级 -->
                <li nz-submenu *ngIf="child.children?.length > 0" [nzKey]="child.id" [nzTitle]="titleTpl"
                  [nzPaddingLeft]="48" (click)="onSelect($event,child.id)">
                  <ng-template #titleTpl>
                    <svg-icon *ngIf="activeTopTabMobile === child.id" [isUrl]="false" [iconName]="'change/folder-active.svg'" [size]="26" class="mr-1"></svg-icon>
                    <svg-icon *ngIf="activeTopTabMobile !== child.id" [isUrl]="false" [iconName]="'change/folder-black.svg'" [size]="26" class="mr-1"></svg-icon>
                    <span  [ngClass]="{
                      'text-[#007BC0]': activeTopTabMobile === child.id,
                      'text-black': activeTopTabMobile !== child.id
                    }">{{ child.name }}</span>
                  </ng-template>
                  <ul>
                    <li nz-menu-item [nzPaddingLeft]="72" *ngFor="let grandChild of child.children"
                      [nzKey]="grandChild.id" (click)="onSelect($event,grandChild.id)">
                      <span [ngClass]="{
                        'text-[#007BC0]': activeTopTabMobile === grandChild.id,
                        'text-black': activeTopTabMobile !== grandChild.id
                      }">{{ grandChild.name }}</span>
                    </li>
                  </ul>
                </li>
              </ng-container>
            </ul>
          </li>
        </div>
      </ul>
      
    </div>
  </div>
  <div class="sm:mt-4"></div>
  <div class="flex gap-4 md:gap-8 sm:bg-[#F4F6F8]">
    <!-- Main Content Area -->
    <div class="flex-1 min-w-0 ">
      <!-- Documents Grid -->
      <div class="grid sm:grid-cols-1 mx:grid-cols-3 gap-4 mx:gap-6 bg-[#F4F6F8] mx:p-6" *ngIf="documents.length>0">
        <nz-card *ngFor="let doc of documents" nzHoverable [nzBodyStyle]="{ padding: '0px', cursor: 'default' }"
          class="transition-shadow">
          <div class="aspect-video bg-gray-100 mb-4 overflow-hidden">
            <img [src]="doc.imageBase64===''?'assets/change/default.jpeg':doc.imageBase64"
              [alt]="doc.imageName===null?'default img':doc.imageName" class="w-full h-full object-cover"
              loading="lazy" />
          </div>

            <h3 class="px-8 text-black font-bold mb-3 mx:text-[18px] sm:text-[15px] truncate max-w-full" [title]=" doc.name">{{ doc.name }}</h3>
            <p  class="px-8 text-black mb-6 line-clamp-2 mx:text-[16px] sm:text-[12px] truncate max-w-full" [title]=" doc.description">{{ doc.description }}</p>
  
          <p class="px-8 text-[#343536] mb-5 mx:text-[14px] sm:text-[12px]">{{'LAST_MODIFIED_TIME' | translate}}: {{
            doc.updateTime }}</p>

          <div class="mx-8 flex items-center justify-between pt-5 border-t border-[#D9D9D9] border-solid mb-6">
            <span class="text-[#007BC0] mx:text-[18px] sm:text-[15px]">{{doc.fileType}}</span>
            <div class="flex">
              <svg-icon [iconName]="'change/link.svg'" *ngIf="doc.url!=='' && !isMobile" (click)="onOpenUrl(doc.url)"
                [size]="36" class="cursor-pointer"></svg-icon>
              <svg-icon [iconName]="'change/download.svg'" *ngIf="!isMobile"
                (click)="onDownloadFile(doc.fileId, doc.fileName)" [size]="36" class="ml-3 cursor-pointer"></svg-icon>
              <svg-icon [iconName]="'change/link.svg'" *ngIf="doc.url!=='' && isMobile" (click)="onOpenUrl(doc.url)"
                [size]="32" class="cursor-pointer"></svg-icon>
              <svg-icon [iconName]="'change/download.svg'" *ngIf="isMobile"
                (click)="onDownloadFile(doc.fileId, doc.fileName)" [size]="32" class="ml-3 cursor-pointer"></svg-icon>

            </div>
          </div>
        </nz-card>
      </div>

      <!-- Empty State -->
      <div *ngIf="documents.length === 0" class="w-full h-[528px] bg-[#F4F6F8] flex flex-center flex-col sm:px-4">
        <img src="assets/change/landscape.svg" class="w-[240px] h-[135px]" />
        <p class="text-black">{{'NO_CONTENT_FOUND' | translate}}</p>
      </div>
    </div>
  </div>
  <!-- Pagination -->
  <div class="mt-9 result-table flex justify-end">
    <nz-pagination [nzTotal]="pagination.total" [nzPageIndex]="pagination.pageIndex" [nzPageSize]="pagination.pageSize"
      [nzShowSizeChanger]="false" (nzPageIndexChange)="pageIndexChange($event)">
    </nz-pagination>
  </div>
</div>
<!-- </nz-spin> -->